import React, { useState, useEffect, useRef} from "react";
import { RiDeleteBin5Line } from "react-icons/ri";
import { CiSearch } from "react-icons/ci";
import { Camera } from "lucide-react";
import axios from "axios";
import { Circles } from 'react-loader-spinner';
import { FadeLoader } from 'react-spinners';


import { BaseUrl } from "../App";
const Addstaff = () => {
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("staff details"); // Main tab state
  const [activeSubTab, setActiveSubTab] = useState("VIEW SLOTS BY?"); // Sub tab state for "Staff availability"
  const [holidays, setHolidays] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [fullMonth, setFullMonth] = useState({});
  const [serviceDetails, setServiceDetails] = useState([]);
  const [selectedStaffId, setSelectedStaffId] = useState(null);
  const [scheduleType, setScheduleType] = useState(null);
  const [availabilityData, setAvailabilityData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [selectedWeek, setSelectedWeek] = useState("1"); // Add state for selected week
  const [breakToDelete, setBreakToDelete] = useState(null); // Track the break to delete
  const [showModal, setShowModal] = useState(false);
  const [breakData, setBreakData] = useState([]); // Added state for breaks data
  const [startTime, setStartTime] = useState(""); // Store start time
  const [endTime, setEndTime] = useState(""); // Store end time
  const [selectedWeekId, setSelectedWeekId] = useState("1"); // Store selected week id
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false); // Track modal visibility
  const [showDeleteModaloff, setShowDeleteModaloff] = useState(false);
  const [selectedBreakId, setSelectedBreakId] = useState(null); // Store the break id to delet
  const [startDateTime, setStartDateTime] = useState(""); // For start date & time
  const [endDateTime, setEndDateTime] = useState(""); // For end date & time
  const [offTimes, setOffTimes] = useState([]); // To store off time
  const [selectedDate, setSelectedDate] = useState(null); // New state to store selected date
  const [offDays, setOffDays] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [services, setServices] = useState([]); // To store all services from API
  const [selectedServices, setSelectedServices] = useState([]); // To store selected services
  const [showServicesDropdown, setShowServicesDropdown] = useState(false); // To toggle dropdown visibility
  const servicesDropdownRef = useRef(null); // Ref for dropdown to handle outside clicks
  const [isServicesLoading, setIsServicesLoading] = useState(true);
  // const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    description: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    profileImage: null,
    enableBooking: false,
  });
  const getDayName = (weekdayId) => {
    const days = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];
    return days[weekdayId - 1] || "N/A";
  };

  const [thisWeekBreaks, setThisWeekBreaks] = useState([
    { day: "Monday", status: "Available", time: "8:00 AM - 8:30 AM" },
    { day: "Tuesday", status: "Available", time: "10:00 AM - 10:30 AM" },
    // Add more days here as needed
  ]);
  const [staffMembers, setStaffMembers] = useState([]);
  useEffect(() => {
    let timer;
    if (error) {
      timer = setTimeout(() => {
        setError("");
      }, 5000); // 5 seconds
    }
    return () => clearTimeout(timer);
  }, [error]);
  const fetchStaffData = async () => {
    // setLoading(true);
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/staff.php`, {
        action: "all_staff_details",
        api_key: "1",
      });

      if (response.data.status === "true") {
        console.log(response.data.response);

        setStaffMembers(response.data.response);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
    // finally {
    //   setLoading(false);
    // }
  };
  useEffect(() => {
    fetchStaffData();
    fetchAllServices(); // Fetch services on component mount
  }, []);
  const fetchStaffDetails = async (id) => {
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/staff.php`, {
        action: "get_staff_details",
        api_key: "1",
        id,
      });
  
      console.log(response.data);
      if (response.data.status === "true") {
        const details = response.data.response;
        setFormData({
          name: details.fullname,
          email: details.email,
          description: details.description,
          phone: details.phone,
          address: details.address,
          city: details.city,
          state: details.state,
          zip: details.zip,
          country: details.country,
          profileImage: details.image,
          enableBooking: details.enable_booking,
          ct_service_staff: details.service_ids,
        });
  
        // Handle assigned services
        if (details.service_ids) {
          const serviceIds = details.service_ids.split(",").map(Number); // Convert "1,2,4" to [1, 2, 4]
          const assignedServices = services.filter((service) =>
            serviceIds.includes(Number(service.id))
          );
          console.log("Assigned services:", assignedServices);
          setSelectedServices(assignedServices);
        } else {
          setSelectedServices([]);
        }
      }
    } catch (error) {
      console.error("Error fetching staff details:", error);
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
 
  const handleStaffClick = async (id) => {
    setSelectedStaffId(id);
    setSelectedStaff(id);
    await fetchStaffDetails(id);
    if (services.length === 0) {
      await fetchAllServices();
    }
  };
  useEffect(() => {
    console.log("11111");

    console.log("hiiiiiiiiii", scheduleType);

    if (selectedStaffId) {
      fetchAvailabilityData(selectedStaffId);
    }
  }, [selectedStaffId]);

  useEffect(() => {
    if (scheduleType == "weekly") {
      setSelectedWeekId("1");
      setSelectedWeek("1");
    }
    fetchBreakData();
    fetchOffTimes();
    fetchOffDays();
  }, [scheduleType, selectedWeekId]);
  // const fetchServiceDetails = async (staffId) => {
  //   // setLoading(true);
  //   try {
  //     const response = await axios.post(
  //       `${BaseUrl}/backend/api/service_detail_staff.php`,
  //       {
  //         action: "get_service_details",
  //         api_key: "1",
  //         type: "staff",
  //         user_id: staffId,
  //       }
  //     );

  //     if (response.data.status === "true") {
  //       setServiceDetails(response.data.response); // Update the state with service details
  //     }
  //   } catch (error) {
  //     console.error("Error fetching service details:", error);
  //   }
  //   // finally {
  //   //   setLoading(false);
  //   // }
  // };
  // const fetchServiceDetails = async (staffId) => {
  //   setLoading(true);
  //   try {
  //     const response = await axios.post(
  //       `${BaseUrl}/backend/api/service_detail_staff.php`,
  //       {
  //         action: "get_service_details",
  //         api_key: "1",
  //         type: "staff",
  //         user_id: staffId,
  //       }
  //     );
  
  //     if (response.data.status === "true") {
  //       const normalizedData = response.data.response.map((service) => ({
  //         ...service,
  //         client_name:
  //           typeof service.client_name === "object" && service.client_name
  //             ? `${service.client_name.first_name || ""} ${service.client_name.last_name || ""}`.trim()
  //             : service.client_name || "N/A",
  //         client_email:
  //           typeof service.client_email === "object" && service.client_email
  //             ? service.client_email.email || "N/A"
  //             : service.client_email || "N/A",
  //       }));
  //       setServiceDetails(normalizedData);
  //     } else {
  //       setError("Failed to fetch service details: " + response.data.response);
  //       setServiceDetails([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching service details:", error);
  //     setError("An error occurred while fetching service details.");
  //     setServiceDetails([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const fetchServiceDetails = async (staffId) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/service_detail_staff.php`,
        {
          action: "get_service_details",
          api_key: "1",
          type: "staff",
          user_id: staffId,
        }
      );
  
      if (response.data.status === "true") {
        const normalizedData = response.data.response.map((service) => ({
          ...service,
          client_name:
            typeof service.client_name === "object" && service.client_name
              ? service.client_name.client_name || "N/A" // Use nested client_name
              : service.client_name || "N/A",
          client_email:
            typeof service.client_name === "object" && service.client_name
              ? service.client_name.client_email || "N/A" // Use nested client_email
              : service.client_email || "N/A",
        }));
        setServiceDetails(normalizedData);
      } else {
        setError("Failed to fetch service details: " + response.data.response);
        setServiceDetails([]);
      }
    } catch (error) {
      console.error("Error fetching service details:", error);
      setError("An error occurred while fetching service details.");
      setServiceDetails([]);
    } finally {
      setLoading(false);
    }
  };
  // Initialize fetch
  useEffect(() => {
    fetchStaffData();
  }, []);

  const staffAvailability = [
    // Add more staff availability data here...
  ];
  const staffData = [
    // Add more data here
  ];

  // Filtered data based on search query
  const filteredData = staffAvailability.filter(
    (staff) =>
      staff.staffName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      staffData.client.toLowerCase().includes(searchQuery.toLowerCase())
  );
  // Pagination logic
  const startIndex = (currentPage - 1) * entriesPerPage;
  const paginatedData =
    entriesPerPage === "All"
      ? filteredData
      : filteredData.slice(startIndex, startIndex + entriesPerPage);

  const totalPages = Math.ceil(filteredData.length / entriesPerPage);

  // Handle search query change
  const handleSearch = (e) => setSearchQuery(e.target.value);

  // Handle entries per page change
  const handleEntriesChange = (e) => {
    setEntriesPerPage(
      e.target.value === "All" ? "All" : parseInt(e.target.value, 10)
    );
    setCurrentPage(1); // Reset to first page
  };

  // Pagination handlers
  const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const handleNextPage = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  const handlePageChange = (page) => setCurrentPage(page);

  const handleToggle = () => {
    setFormData((prevData) => ({
      ...prevData,
      enableBooking: prevData.enableBooking === "Y" ? "N" : "Y", // Toggle correctly
    }));
  };

  const handleProfileImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prev) => ({ ...prev, profileImage: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };
  const months = [
    "January 2025",
    "February 2025",
    "March 2025",
    "April 2025",
    "May 2025",
    "June 2025",
    "July 2025",
    "August 2025",
    "September 2025",
    "October 2025",
    "November 2025",
    "December 2025",
  ];
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    // Prepare the array of service IDs
    const serviceIds = selectedServices.map(service => Number(service.id)); // Ensure IDs are numbers
  
    const updatedData = {
      action: "update_staff",
      api_key: "1",
      id: selectedStaffId,
      fullname: formData.name,
      email: formData.email,
      description: formData.description,
      phone: formData.phone,
      address: formData.address,
      city: formData.city,
      state: formData.state,
      zip: formData.zip,
      country: formData.country,
      enable_booking: formData.enableBooking === "Y" ? "Y" : "N",
      ct_service_staff: serviceIds, // Pass as array [1, 2, 4]
      image: formData.profileImage || "",
      pass: formData.password || "" // Include password if it exists
    };
  
    try {
      console.log("Payload being sent:", updatedData); // Debug payload
      const response = await axios.post(
        `${BaseUrl}/backend/api/staff.php`,
        updatedData,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
  
      console.log("API Response:", response.data); // Debug response
  
      if (response.data.status === "true") {
        setSuccessMessage("Staff Details Updated Successfully!");
        setStaffMembers((prevStaff) =>
          prevStaff.map((staff) =>
            staff.id === selectedStaffId ? { ...staff, ...response.data.response } : staff
          )
        );
      } else {
        setError("Failed to update staff details: " + response.data.response);
      }
    } catch (error) {
      console.error("Error updating staff details:", error);
      setError("An error occurred while updating staff details: " + error.message);
    } finally {
      setLoading(false);
    }
  };
  const handleStatusToggle = (index) => {
    const updatedBreaks = [...thisWeekBreaks];
    updatedBreaks[index].status =
      updatedBreaks[index].status === "On" ? "Off" : "On";
    setThisWeekBreaks(updatedBreaks); // Update the state with the new status
  };

  const toggleMonth = async (month) => {
    const isMonthSelected = fullMonth[month];
    setFullMonth((prev) => ({
      ...prev,
      [month]: !isMonthSelected,
    }));
    // setLoading(true);
    if (!isMonthSelected) {
      // If the month is selected, add all days of the month as off days
      const year = new Date().getFullYear();
      const monthIndex = months.indexOf(month);
      const allDays = [...Array(31).keys()].map((dayIndex) => {
        const date = new Date(year, monthIndex, dayIndex + 1);
        return date.toISOString().split("T")[0]; // Formatting date as YYYY-MM-DD
      });
      setOffDays((prev) => [...prev, ...allDays]); // Append all days as off days
    } else {
      // If the month is unchecked, delete off days for that month
      const year = new Date().getFullYear();
      const fullMonthDate = `${year}-${(months.indexOf(month) + 1)
        .toString()
        .padStart(2, "0")}`; // Format as "YYYY-MM"

      // Call the API to delete off days for the entire month
      try {
        const response = await axios.post(
          `${BaseUrl}/backend/api/schedule.php`,
          {
            action: "delete_month_off_day", // Action for deleting full month off days
            api_key: "1", // API key
            provider_id: selectedStaffId, // Provider ID
            date: fullMonthDate, // The month in YYYY-MM format
          }
        );

        if (response.data.status === "true") {
          setSuccessMessage("Delete Month Off Day Successfully!");
          // alert(`Off days for ${month} deleted successfully!`);
          fetchOffDays(); // Refresh off days after deletion
        } else {
          alert("Failed to delete off days for the month.");
        }
      } catch (error) {
        console.error("Error deleting off days for the month:", error);
        alert("An error occurred while deleting off days for the month.");
      }
      // finally {
      //   setLoading(false);
      // }
    }

    setSelectedMonth(!isMonthSelected ? month : null); // Set selected month or reset
  };

  const isDayHoliday = (month, dayNumber) => {
    const formattedDate = new Date(
      new Date().getFullYear(),
      months.indexOf(month),
      dayNumber
    )
      .toISOString()
      .split("T")[0];

    // Check if the date exists in the offDays array
    return (
      offDays.some((offDay) => offDay.off_date === formattedDate) ||
      (fullMonth[month] &&
        months.indexOf(month) === months.indexOf(selectedMonth)) // Check if the full month is selected and add all days as holiday
    );
  };
  const isDaySelected = (month, dayNumber) => {
    if (selectedMonth) {
      return months.indexOf(selectedMonth) === months.indexOf(month); // If month is selected, all days in that month should be highlighted
    }
    return (
      selectedDate ===
      new Date(new Date().getFullYear(), months.indexOf(month), dayNumber)
        .toISOString()
        .split("T")[0]
    ); // Check for individual day selection
  };

  const toggleDay = (month, dayNumber) => {
    const date = new Date(); // Current date
    const selectedDate = new Date(
      date.getFullYear(),
      months.indexOf(month),
      dayNumber
    ); // Construct the selected date
    setSelectedDate(selectedDate.toISOString().split("T")[0]); // Format it as 'YYYY-MM-DD'
    console.log(`Selected Date: ${selectedDate.toISOString().split("T")[0]}`);
  };
  const handleAddOffDay = async () => {
    // setLoading(true);
    if (!selectedDate) {
      alert("Please select a date for your off day.");
      return;
    }
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
        action: "add_off_day", // Action to add an off day
        api_key: "1", // API key
        prov_id: selectedStaffId, // User ID from localStorage
        date: selectedDate,
      });
      if (response.data.status === "true") {
        setSuccessMessage("Add Off Day Successfully!");
        // alert("Off day added successfully!");
        fetchOffTimes(); // Refresh off times after adding
      } else {
        alert("Failed to add off day.");
      }
    } catch (error) {
      console.error("Error adding off day:", error);
      alert("An error occurred while adding the off day.");
    }
    // finally {
    //   setLoading(false);
    // }
  };
  const handleAddOffFullMonth = async () => {
    setLoading(true);
    if (!selectedMonth) {
      alert("Please select a month for your off days.");
      return;
    }
    const year = new Date().getFullYear();
    const fullMonth = `${year}-${months.indexOf(selectedMonth) + 1}`.padStart(
      7,
      "0"
    ); // e.g. "2025-03"
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
        action: "add_month_off_day", // Action to add off days for the full month
        api_key: "1", // Your API key
        provider_id: selectedStaffId, // Provider ID (selectedStaffId)
        date: fullMonth, // Send just the formatted "YYYY-MM" string
      });

      if (response.data.status === "true") {
        setSuccessMessage("Add Month Off Day Successfully!");
        // alert("Off days for the full month added successfully!");
      } else {
        alert("Failed to add off days for the full month.");
      }
    } catch (error) {
      console.error("Error adding off days for the full month:", error);
      alert("An error occurred while adding off days for the full month.");
    }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === "OFF DAYS" && selectedStaffId) {
      fetchOffDays(); // Fetch off days data when tab is active
    }
  }, [activeTab, selectedStaffId]);

  const fetchOffDays = async () => {
    setIsLoading(true); // Set loading state
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
        action: "get_off_day", // Action to get off days
        api_key: "1", // API key
        staff_id: selectedStaffId, // Fetch for the current user
      });
      if (response.data.status === "true") {
        const fetchedOffDays = response.data.data || [];
        setOffDays(fetchedOffDays); // Store off days data

        // Check if full month is selected for any of the fetched off days
        const monthsWithOffDays = fetchedOffDays.map((offDay) => {
          const monthIndex = new Date(offDay.off_date).getMonth();
          return months[monthIndex]; // Get the month name
        });

        // Update fullMonth state based on fetched off days
        const newFullMonth = {};
        monthsWithOffDays.forEach((month) => {
          newFullMonth[month] = true; // Mark months with off days as selected
        });
        setFullMonth(newFullMonth);
      } else {
        setOffDays([]); // No off days found
      }
    } catch (error) {
      console.error("Error fetching off days:", error);
      alert("Failed to load off days. Please try again.");
    }
    finally {
      setLoading(false);
    }
    
  };

  const handleDeleteOffDay = async (offDay) => {
    setIsLoading(true); // Set loading state
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
        action: "delete_off_day", // API action to delete an off day
        api_key: "1", // API key
        user_id: selectedStaffId, // User ID (from localStorage)
        date: offDay.off_date, // The actual off day date to delete (corrected)
        id: offDay.id, // The off day ID to uniquely identify it
      });
      if (response.data.status === "true") {
        setSuccessMessage("Delete Off Day Successfully!");
        // alert("Off day deleted successfully!");
        fetchOffDays(); // Refresh the off days data after successful deletion
      } else {
        alert("Failed to delete off day.");
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error deleting off day:", error);
      alert("An error occurred while deleting the off day.");
      setIsLoading(false);
    }
    finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const fetchedUserId = sessionStorage.getItem("selectedStaffId");
    console.log("Fetched selectedStaffId:", fetchedUserId); // Check what is logged
    if (fetchedUserId) {
      setSelectedStaffId(fetchedUserId);
      fetchAvailabilityData(fetchedUserId);
    }
  }, []);
  const fetchAvailabilityData = async (providerId) => {
    setIsLoading(true);
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
        action: "get_schedule_all_data",
        provider_id: providerId,
      });
      console.log("API Response:",response.data); // Log the full response data
      if (response.data.status !== "true") {
        alert("Error: " + response.data.response);
        return;
      }
      const data = Array.isArray(response.data.response)
        ? response.data.response
        : [];
      setAvailabilityData(data);
      console.log("Availability Data:", data); // Log the availability data

      if (data.length > 0) {
        setScheduleType(data[0].provider_schedule_type || null);
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching availability data:", error);
      alert("Failed to load schedule data.");
      // setIsLoading(false);
    }
    finally {
      setLoading(false);
    }
  };
  const handleToggleChange = async () => {

    const newScheduleType = scheduleType === "weekly" ? "monthly" : "weekly";
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
        action: "change_schedule_type",
        api_key: "1", // Replace with actual API key
        values: newScheduleType,
        staff_id: selectedStaffId,
      });
      if (response.data.status === "true") {
        setSuccessMessage("Schedule Type Updated Successfully!");
        setScheduleType(newScheduleType);
        setSelectedWeek("1"); // Reset to first week when switching schedule type
        fetchAvailabilityData(selectedStaffId); // Re-fetch the availability data when schedule type changes
      } else {
        alert("Failed to update schedule type: " + response.data.response);
      }
    } catch (error) {
      console.error("Error updating schedule type:", error);
      alert("Error updating schedule type");
    }
  };
  const handleWeekChange = (e) => {
    const newSelectedWeek = e.target.value;

    setSelectedWeek(newSelectedWeek); // Update selected week
    setSelectedWeekId(newSelectedWeek); // Update selected week id (can be different if required)
  };
  const filteredDataByWeek = () => {
    if (!availabilityData || availabilityData.length === 0) {
      return [];
    }
    return availabilityData.filter(
      (item) =>
        item.provider_schedule_type === scheduleType &&
        parseInt(item.week_id) === parseInt(selectedWeek) // This will use selectedWeek for filtering
    );
  };
  const handleAddBreak = async (weekdayId) => {
    setLoading(true);
    const weekId = selectedWeekId; // Yahan week_id ko dynamic value milega
    if (!startTime || !endTime) {
      alert("Please select both start and end times.");
      return;
    }
    try {
      const response = await axios.post(
        `${BaseUrl}megaclean/backend/api/schedule.php`,
        {
          action: "add_break",
          api_key: "1",
          weekid: weekId, // Week_id ko pass kar rahe hain
          weekday: weekdayId,
          staff_id: selectedStaffId,
          starttime: startTime,
          endtime: endTime,
        }
      );
      if (response.data.status === "true") {
        setSuccessMessage("Break Added Successfully!");
        // alert("Break added successfully!");
        // Refresh breaks data
        fetchAvailabilityData(selectedStaffId);
      } else {
        alert("Failed to add break: " + response.data.response);
      }
    } catch (error) {
      console.error("Error adding break:", error);
      alert("Error adding break.");
    }
    finally {
      setLoading(false);
    }
  };
  const fetchBreakData = async () => {
    setLoading(true);
    console.log(
      "selectedStaffId for fetchBreakData:",
      selectedStaffId,
      scheduleType
    ); // Check selectedStaffId before making API call
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
        action: "get_break",
        api_key: "1",
        staff_id: selectedStaffId, // Ensure selectedStaffId is being passed here
        week_id: scheduleType === "weekly" ? "1" : selectedWeekId,
        // weekday_id: selectedWeek,
      });
      if (response.data.status === "true") {
        setBreakData(response.data.data); // Store break data in state
      } else {
        setBreakData([]); // No breaks found
      }
    } catch (error) {
      console.error("Error fetching break data:", error);
      alert("Failed to load break data. Please try again.");
    }
    finally {
      setLoading(false);
    }
  };

  const handleConfirmDelete = async () => {
    if (!selectedBreakId) return;
    setIsLoading(true);
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
        action: "delete_break",
        api_key: "1",
        id: selectedBreakId,
      });
      if (response.data.status === "true") {
        setSuccessMessage("Break Deleted Successfully!");
        // alert("Break deleted successfully!");
        fetchBreakData(); // Refresh breaks data
      } else {
        alert("Failed to delete break.");
      }
      setIsLoading(false);
      setShowDeleteModal(false); // Close the modal
    } catch (error) {
      console.error("Error deleting break:", error);
      alert("An error occurred while deleting the break.");
      // setIsLoading(false);
      setShowDeleteModal(false); // Close the modal
    }
    finally {
      setLoading(false);
    }
  };
  const handleAddOffTime = async () => {
    setLoading(true);
    if (!startDateTime || !endDateTime) {
      alert("Please select both start date and end date.");
      return;
    }
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
        action: "add_offtime", // Action for the API
        api_key: "1", // API key
        startdate: startDateTime, // Start date-time from the input
        enddate: endDateTime, // End date-time from the input
        staff_id: selectedStaffId, // User ID (staff_id) from state
      });
      if (response.data.status === "true") {
        setSuccessMessage("Off Time Added Successfully!");
        // alert("Off time added successfully!");
      } else {
        alert("Failed to add off time.");
      }
    } catch (error) {
      console.error("Error adding off time:", error);
      alert("An error occurred while adding the off time.");
    }
    finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    // setLoading(true);
    if (activeTab === "OFF TIME" && selectedStaffId) {
      fetchOffTimes(); // Fetch off times data when tab is active
    }
  }, [activeTab, selectedStaffId]);
  const fetchOffTimes = async () => {
    setIsLoading(true); // Set loading state to true while fetching
    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/schedule.php`, // Endpoint for getmy_offtimes
        {
          action: "getmy_offtimes",
          api_key: "1", // API key
          staff_id: selectedStaffId, // Pass selectedStaffId dynamically here
        }
      );
      console.log("API Response:", response.data); // Log the API response to inspect the structure

      // Check if the response status is true and update the state
      if (response.data.status === "true") {
        setOffTimes(response.data.response || []); // Set fetched off time data
      } else {
        setOffTimes([]); // No off times found, set an empty array
      }
    } catch (error) {
      console.error("Error fetching off times:", error);
      alert("Failed to load off time data. Please try again.");
    }
    finally {
      setLoading(false);
    }
    // setIsLoading(false); // Set loading state to false once fetching is complete
  };
  // Handle delete confirmation modal
  const handleDelete = (offTimeId) => {
    setDeleteItemId(offTimeId); // Store the ID of the off time to delete
    setShowDeleteModaloff(true); // Show the modal
  };
  // Confirm deletion
  const confirmDelete = async () => {
    setLoading(true);
    if (!deleteItemId) return;
    setIsLoading(true); // Show loading state during API call
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
        action: "delete_offtime",
        api_key: "1", // API key
        id: deleteItemId, // Pass the off time ID to delete
      });
      if (response.data.status === "true") {
        setSuccessMessage("Off Time Deleted Successfully!");
        // alert("Off time deleted successfully!");
        fetchOffTimes(); // Re-fetch the off times to update the list
      } else {
        alert("Failed to delete off time.");
      }
      setIsLoading(false);
      setShowDeleteModaloff(false); // Close the modal after deletion
    } catch (error) {
      console.error("Error deleting off time:", error);
      alert("An error occurred while deleting the off time.");
      setIsLoading(false);
      setShowDeleteModaloff(false); // Close the modal even on error
    }
    finally {
      setLoading(false);
    }
  };
  // Handle clicking outside the dropdown to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        servicesDropdownRef.current &&
        !servicesDropdownRef.current.contains(event.target) // Fix: Use event.target
      ) {
        console.log("Clicked outside, closing dropdown");
        setShowServicesDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  // New function to handle service selection
  const handleServiceSelect = (service) => {
    setSelectedServices((prev) => {
      const isSelected = prev.some((s) => Number(s.id) === Number(service.id));
      console.log("Is Selected:", isSelected, "Service ID:", service.id);
      const updated = isSelected
        ? prev.filter((s) => Number(s.id) !== Number(service.id))
        : [...prev, service];
      console.log("Updated selectedServices:", updated);
      return updated;
    });
    console.log("Dropdown state after selection:", showServicesDropdown); // Should still be true
  };
  // New function to handle service removal
  const handleServiceRemove = (serviceId) => {
    setSelectedServices((prev) => {
      const updatedServices = prev.filter((service) => service.id !== serviceId);
      console.log("After removal, selectedServices:", updatedServices);
      return updatedServices;
    });
  };
  
  const fetchAllServices = async () => {
    try {
      setIsServicesLoading(true);
      const response = await axios.post(`${BaseUrl}/backend/api/services.php`, {
        action: "get_all_services",
        api_key: "1",
      });
      if (response.data.status === "true") {
        console.log("Services fetched:", response.data.response);
        setServices(response.data.response || []);
      } else {
        console.error("Failed to fetch services:", response.data.response);
        setServices([]);
      }
    } catch (error) {
      console.error("Error fetching services:", error);
      setServices([]);
    } finally {
      setIsServicesLoading(false);
    }
  };
  const cancelDelete = () => {
    setShowDeleteModaloff(false); // Close the modal
  };
  const handleDeleteBreak = (breakId) => {
    setSelectedBreakId(breakId); // Save the break id to be deleted
    setShowDeleteModal(true); // Show the modal for confirmation
  };

  return (
    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         
    <div className="container mx-auto mt-8 px-4 sm:px-6 lg:px-8 bg-white xl:px-20">
              {successMessage && (
            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
              <span className="block sm:inline">{successMessage}</span>
            </div>
          )}

          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
              <span className="block sm:inline">{error}</span>
            </div>
          )}
      <div className="flex flex-col md:flex-row gap-2">
        {/* Staff Members Section */}
        <div className="w-full md:w-56 bg-white border-r border-gray-200 p-4 mb-6 md:mb-0">
          <div className="mb-4">
            <h2 className="text-lg font-medium text-gray-700">
              Staff Members ({staffMembers.length})
            </h2>
          </div>
          <div>
            <div className="block md:hidden space-y-2">
              {staffMembers.map((member) => (
                <div
                  key={member.id}
                  onClick={() => handleStaffClick(member.id)}
                  className={`flex items-center cursor-pointer p-2 ${
                    selectedStaff === member.id ? 'bg-blue-500 text-white' : 'hover:bg-gray-100'
                  }`}
                >
                  <img
                    src={member.image}
                    alt={member.fullname}
                    className="w-8 h-8 rounded-full border-2 border-indigo-400"
                  />
                  <span className="ml-2 text-sm text-gray-600 hover:text-indigo-700 font-medium">
                    {member.fullname}
                  </span>
                </div>
              ))}
            </div>
              <div className="hidden md:block space-y-2">
                {staffMembers.map((member) => (
                  <div
                    key={member.id}
                    onClick={() => handleStaffClick(member.id)}
                    className={`flex items-center cursor-pointer p-2 ${
                      selectedStaff === member.id ? 'bg-blue-400 text-white' : 'hover:bg-gray-100'
                    }`}
                  >
                    <img
                      src={member.image}
                      alt={member.fullname}
                      className="w-8 h-8 rounded-full border-2 border-indigo-400"
                    />
                    <span className="ml-2 text-sm text-black hover:text-indigo-700 font-medium">
                      {member.fullname}
                    </span>
                  </div>
                ))}
              </div>

          </div>
        </div>

        {/* Main Content Area */}
        <div className="flex-1">
          {/* Main Tabs */}
          <div className="flex flex-wrap justify-between border-b sm:border-b-4 md:border-b-8 border-gray-300 pb-4 mb-6 gap-2">
            {["staff details", "service details", "Staff availability"].map(
              (tab) => (
                <button
                  key={tab}
                  className={`flex-1 text-center px-2 sm:px-4 py-2 text-nowrap text-xs sm:text-sm font-medium rounded-lg transition-colors duration-300 ease-in-out ${
                    activeTab === tab
                      ? "bg-blue-500 border-b-4 border-blue-500 font-semibold text-white"
                      : "border-b-4 border-transparent text-gray-600 hover:text-blue-400 hover:border-blue-300 bg-slate-50"
                  }`}
                  onClick={() => {
                    setActiveTab(tab);
                    if (tab === "service details") {
                      fetchServiceDetails(selectedStaffId); // Fetch service details when tab is clicked
                    }
                  }}
                >
                  {tab}
                </button>
              )
            )}
          </div>

          {/* Main Tab Content */}
          <div className=" sm:p-4">
            {activeTab === "staff details" && (
              <div className="flex min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
                {/* Main Content */}
                <div className="flex-1 flex items-center justify-center px-2 sm:px-6">
                  {" "}
                  {/* Less padding for mobile */}
                  <div className="w-full max-w-md sm:max-w-4xl">
                    {" "}
                    {/* More width on mobile */}
                    <div className="mb-6 sm:mb-8 text-center">
                      <h1 className="text-2xl sm:text-4xl font-bold text-gray-800">
                        {formData.name || "Staff Members"}
                      </h1>
                    </div>
                    {/* Form Section */}
                    <form
                      onSubmit={handleSubmit}
                      className="bg-white shadow-xl rounded-xl p-4 sm:p-8 w-full transition-transform hover:scale-[1.01]"
                    >
                      {/* Profile Image */}
                      <div className="mb-6 sm:mb-8 flex justify-center">
                        <div className="relative">
                          <div
                            className="w-20 h-20 sm:w-28 sm:h-28 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden border-4 border-white shadow-lg"
                            style={{
                              backgroundImage: formData.profileImage
                                ? `url(${formData.profileImage})`
                                : "none",
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                            }}
                          >
                            {!formData.profileImage && (
                              <Camera className="w-8 sm:w-10 h-8 sm:h-10 text-gray-400" />
                            )}
                          </div>
                          <input
                            type="file"
                            id="profileImage"
                            onChange={handleProfileImageChange}
                            className="hidden"
                            accept="image/*"
                          />
                          <label
                            htmlFor="profileImage"
                            className="absolute bottom-0 right-0 bg-blue-500 hover:bg-blue-600 rounded-full p-1 sm:p-2 cursor-pointer shadow-md transition-colors"
                          >
                            <Camera className="w-3 sm:w-4 h-3 sm:h-4 text-white" />
                          </label>
                        </div>
                      </div>

                      <div className="space-y-4 sm:space-y-6">
                        <div>
                          <label className="block text-sm font-medium text-gray-700">
                            Name
                          </label>
                          <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            className="mt-1 w-full p-2 sm:p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-shadow"
                            placeholder="Enter staff name"
                          />
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700">
                            Email Address
                          </label>
                          <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className="mt-1 w-full p-2 sm:p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-shadow"
                            placeholder="Enter email address"
                          />
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700">
                            Description
                          </label>
                          <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            rows="3"
                            className="mt-1 w-full p-2 sm:p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-shadow"
                          ></textarea>
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700">
                            Phone
                          </label>
                          <input
                            type="text"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            className="mt-1 w-full p-2 sm:p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-shadow"
                            placeholder="Enter phone number"
                          />
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700">
                            Address
                          </label>
                          <input
                            type="text"
                            name="address"
                            value={formData.address}
                            onChange={handleChange}
                            className="mt-1 w-full p-2 sm:p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-shadow"
                            placeholder="Enter address"
                          />
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                          <div>
                            <label className="block text-sm font-medium text-gray-700">
                              City
                            </label>
                            <input
                              type="text"
                              name="city"
                              value={formData.city}
                              onChange={handleChange}
                              className="mt-1 w-full p-2 sm:p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-shadow"
                            />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700">
                              State
                            </label>
                            <input
                              type="text"
                              name="state"
                              value={formData.state}
                              onChange={handleChange}
                              className="mt-1 w-full p-2 sm:p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-shadow"
                            />
                          </div>
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                          <div>
                            <label className="block text-sm font-medium text-gray-700">
                              Zip
                            </label>
                            <input
                              type="text"
                              name="zip"
                              value={formData.zip}
                              onChange={handleChange}
                              className="mt-1 w-full p-2 sm:p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-shadow"
                            />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700">
                              Country
                            </label>
                            <input
                              type="text"
                              name="country"
                              value={formData.country}
                              onChange={handleChange}
                              className="mt-1 w-full p-2 sm:p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 transition-shadow"
                            />
                          </div>
                        </div>

                        <div className="flex items-center justify-between bg-gray-50 p-3 sm:p-4 rounded-lg">
                          <span className="text-sm font-medium text-gray-700">
                            Enable Booking
                          </span>
                          <button
                            type="button"
                            onClick={handleToggle}
                            className={`w-10 sm:w-12 h-5 sm:h-6 rounded-full p-1 transition-colors duration-200 ${
                              formData.enableBooking === "Y"
                                ? "bg-green-500"
                                : "bg-red-500"
                            }`}
                          >
                            <div
                              className={`w-3 sm:w-4 h-3 sm:h-4 bg-white rounded-full transform transition-transform duration-200 ${
                                formData.enableBooking === "Y"
                                  ? "translate-x-5 sm:translate-x-6"
                                  : "translate-x-0"
                              }`}
                            />
                          </button>
                        </div>
                        <div>
                        <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Services <span className="text-red-500">*</span>
                        </label>
                        <div className="relative" ref={servicesDropdownRef}>
                          <div
                            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 cursor-pointer"
                            onClick={() => {
                              console.log("Parent clicked, toggling dropdown. Current state:", showServicesDropdown);
                              setShowServicesDropdown((prev) => {
                                console.log("New dropdown state:", !prev);
                                return !prev;
                              });
                            }}
                          >
                            <div className="flex flex-wrap gap-2 min-h-[24px]">
                              {selectedServices.length > 0 ? (
                                selectedServices.map((service) => (
                                  <div
                                    key={service.id}
                                    className="bg-blue-100 text-blue-800 px-2 py-1 rounded-md flex items-center gap-1"
                                  >
                                    <span>{service.title}</span>
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleServiceRemove(service.id);
                                      }}
                                      className="text-blue-800 hover:text-blue-900"
                                    >
                                      ×
                                    </button>
                                  </div>
                                ))
                              ) : (
                                <span className="text-gray-500">Select services</span>
                              )}
                            </div>
                          </div>
                          {showServicesDropdown && (
                            <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                              {isServicesLoading ? (
                                <div className="p-2 text-gray-500">Loading services...</div>
                              ) : services.length > 0 ? (
                                services.map((service) => (
                                  <div
                                    key={service.id}
                                    className={`p-2 cursor-pointer hover:bg-gray-100 ${
                                      selectedServices.some((s) => Number(s.id) === Number(service.id))
                                        ? "bg-blue-100 text-blue-800"
                                        : ""
                                    }`}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      console.log("Service item clicked:", service.id);
                                      handleServiceSelect(service);
                                    }}
                                  >
                                    {service.title}
                                  </div>
                                ))
                              ) : (
                                <div className="p-2 text-gray-500">No services available</div>
                              )}
                            </div>
                          )}
                        </div>
                                                      </div>
                      </div>
                        <button
                          type="submit"
                          disabled={loading}
                          className="w-full bg-blue-500 hover:bg-blue-600 text-white py-2 sm:py-3 px-4 rounded-lg font-medium shadow-md transition-colors"
                        >
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            )}
       {activeTab === "service details" && (
              <div className="container mx-auto mt-8 px-4 sm:px-6 lg:px-8 bg-white xl:px-24">
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                  Service Details
                </h2>

                {/* Table for Larger Screens */}
                <div className="overflow-x-auto hidden md:block">
                  <table className="min-w-full table-auto bg-white border border-gray-300 shadow-md rounded-lg">
                    <thead>
                      <tr className="text-left bg-gray-100">
                        <th className="px-4 py-2 border-b">Order ID</th>
                        <th className="px-4 py-2 border-b">Client</th>
                        <th className="px-4 py-2 border-b">Staff Name</th>
                        <th className="px-4 py-2 border-b">Service Name</th>
                        <th className="px-4 py-2 border-b">Order Date</th>
                        <th className="px-4 py-2 border-b">Order Time</th>
                        <th className="px-4 py-2 border-b">Commission Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {serviceDetails.length > 0 ? (
                        serviceDetails.map((service, index) => (
                          <tr key={index} className="border-b hover:bg-gray-50">
                            <td className="px-4 py-2">{service.order_id}</td>
                            <td className="px-4 py-2">{service.client_name}</td>
                            <td className="px-4 py-2">{service.staff_name}</td>
                            <td className="px-4 py-2">{service.service_name}</td>
                            <td className="px-4 py-2">{service.appointment_date}</td>
                            <td className="px-4 py-2">{service.appointment_time}</td>
                            <td className="px-4 py-2">{service.commissionTotal}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan="7"
                            className="px-4 py-2 text-center text-gray-600"
                          >
                            No service details available for this staff member.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Card View for Mobile Screens */}
                <div className="block md:hidden space-y-4">
                  {serviceDetails.length > 0 ? (
                    serviceDetails.map((service, index) => (
                      <div
                        key={index}
                        className="bg-white p-5 rounded-2xl shadow-lg border border-gray-200"
                      >
                        <p className="text-gray-800 font-semibold text-lg">
                          <b className="text-blue-600">Order ID:</b>
                          <span className="font-medium text-gray-700">
                            {" "}
                            {service.order_id}
                          </span>
                        </p>
                        <p className="text-gray-800 font-semibold">
                          <b className="text-blue-600">Client:</b>
                          <span className="font-medium text-gray-700">
                            {" "}
                            {service.client_name}
                          </span>
                        </p>
                        <p className="text-gray-800 font-semibold">
                          <b className="text-blue-600">Staff Name:</b>
                          <span className="font-medium text-gray-700">
                            {" "}
                            {service.staff_name}
                          </span>
                        </p>
                        <p className="text-gray-800 font-semibold">
                          <b className="text-blue-600">Service Name:</b>
                          <span className="font-medium text-gray-700">
                            {" "}
                            {service.service_name}
                          </span>
                        </p>
                        <p className="text-gray-800 font-semibold">
                          <b className="text-blue-600">Order Date:</b>
                          <span className="font-medium text-gray-700">
                            {" "}
                            {service.appointment_date}
                          </span>
                        </p>
                        <p className="text-gray-800 font-semibold">
                          <b className="text-blue-600">Order Time:</b>
                          <span className="font-medium text-gray-700">
                            {" "}
                            {service.appointment_time}
                          </span>
                        </p>
                        <p className="text-gray-800 font-semibold">
                          <b className="text-blue-600"> Bokking Amount:</b>
                          <span className="font-medium text-gray-700">
                            {" "}
                            {service.commissionTotal}
                          </span>
                        </p>
                      </div>
                    ))
                  ) : (
                    <p className="text-center text-gray-600 text-lg">
                      No service details available for this staff member.
                    </p>
                  )}
                </div>
              </div>
            )}

            {activeTab === "Staff availability" && (
              <div>
                {/* Mobile and Desktop Sub-tabs for "Staff availability" */}
                <div className="border-b border-gray-300 pb-4 mb-6">
                  {/* Mobile Dropdown */}
                  <div className="md:hidden w-full">
                    <select
                      className="w-full p-2 border border-gray-300 rounded-lg bg-white text-gray-700"
                      value={activeSubTab}
                      onChange={(e) => setActiveSubTab(e.target.value)}
                    >
                      {[
                        "AVAILABILITY",
                        "ADD BREAKS",
                        "OFF TIME",
                        "OFF DAYS",
                      ].map((subTab) => (
                        <option key={subTab} value={subTab}>
                          {subTab}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Desktop Tabs */}
                  <div className="hidden md:flex flex-nowrap justify-between">
                    <div className="flex flex-row w-full gap-2">
                      {[
                        "AVAILABILITY",
                        "ADD BREAKS",
                        "OFF TIME",
                        "OFF DAYS",
                      ].map((subTab) => (
                        <button
                          key={subTab}
                          className={`flex-1 text-center px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-300 ease-in-out ${
                            activeSubTab === subTab
                              ? "bg-blue-500 border-b-4 border-blue-500 font-semibold text-white"
                              : "border-b-4 border-transparent text-gray-600 hover:text-blue-400 hover:border-blue-300 bg-slate-50"
                          }`}
                          onClick={() => setActiveSubTab(subTab)}
                        >
                          {subTab}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Sub-tab Content */}
                <div className="p-2 sm:p-6">
                  {activeSubTab === "AVAILABILITY" && (
                    <div>
                      {/* Week Dropdown */}
                      <div className="mb-4">
                        {scheduleType === "weekly" ? (
                          <span>This Week</span> // Show "This Week" for weekly schedule
                        ) : (
                          <select
                            className="bg-white border-gray-300 rounded-lg p-2"
                            value={selectedWeek}
                            onChange={handleWeekChange} // This will update selectedWeek when changed
                          >
                            <option value="1">First Week</option>
                            <option value="2">Second Week</option>
                            <option value="3">Third Week</option>
                            <option value="4">Fourth Week</option>
                            <option value="5">Fifth Week</option>
                          </select>
                        )}
                      </div>
                      {/* Display Selected Week */}
                      <div className="mb-4">
                        <h3 className="text-lg font-semibold">
                          Selected Week:{" "}
                          {selectedWeek === "1"
                            ? "First Week"
                            : selectedWeek === "2"
                            ? "Second Week"
                            : selectedWeek === "3"
                            ? "Third Week"
                            : selectedWeek === "4"
                            ? "Fourth Week"
                            : "Fifth Week"}
                        </h3>
                      </div>
                      {/* Availability Table */}
                      <div className="overflow-x-auto mt-12">
                        <table className="min-w-full border-collapse border shadow-lg rounded-xl">
                          <thead>
                            <tr className="bg-blue-200">
                              <th className="border border-blue-300 px-2 sm:px-6 py-3 text-left text-blue-800 text-sm sm:text-base">
                                Day
                              </th>
                              <th className="border border-blue-300 px-2 sm:px-6 py-3 text-left text-blue-800 text-sm sm:text-base">
                                Status
                              </th>
                              <th className="border border-blue-300 px-2 sm:px-6 py-3 text-left text-blue-800 text-sm sm:text-base">
                                Start Time
                              </th>
                              <th className="border border-blue-300 px-2 sm:px-6 py-3 text-left text-blue-800 text-sm sm:text-base">
                                End Time
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {availabilityData && availabilityData.length > 0 ? (
                              filteredDataByWeek().map((item, index) => (
                                <tr
                                  key={item.id || index}
                                  className="hover:bg-blue-100"
                                >
                                  <td className="border border-blue-300 px-2 sm:px-6 py-3 text-blue-700 text-sm sm:text-base">
                                    {item.weekday_id
                                      ? `Day ${item.weekday_id}`
                                      : "N/A"}
                                  </td>
                                  <td className="border border-blue-300 px-2 sm:px-6 py-3">
                                    {item.off_day === "N" ? (
                                      <span className="text-green-600 font-bold">
                                        On
                                      </span>
                                    ) : (
                                      <span className="text-red-600 font-bold">
                                        Off
                                      </span>
                                    )}
                                  </td>
                                  <td className="border border-blue-300 px-2 sm:px-6 py-3 text-blue-700 text-sm sm:text-base">
                                    {item.day_start_time || "N/A"}{" "}
                                    {/* Replace with correct field */}
                                  </td>
                                  <td className="border border-blue-300 px-2 sm:px-6 py-3 text-blue-700 text-sm sm:text-base">
                                    {item.day_end_time || "N/A"}{" "}
                                    {/* Replace with correct field */}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan="4"
                                  className="text-center px-6 py-4 text-sm sm:text-base"
                                >
                                  No availability data found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                  {activeSubTab === "ADD BREAKS" && (
                    <div className="w-full px-2 sm:px-0">
                      {/* Week Dropdown */}
                      <div className="mb-4 w-full">
                        {scheduleType === "weekly" ? (
                          <span className="font-semibold text-lg block w-full">
                            This Week
                          </span>
                        ) : (
                          <select
                            className="bg-white border-gray-300 rounded-lg p-2 w-full"
                            value={selectedWeek}
                            onChange={handleWeekChange}
                          >
                            <option value="1">First Week</option>
                            <option value="2">Second Week</option>
                            <option value="3">Third Week</option>
                            <option value="4">Fourth Week</option>
                            <option value="5">Fifth Week</option>
                          </select>
                        )}
                      </div>

                      {/* Mapping weekday IDs to names */}
                      {/* Mapping weekday IDs to names */}
                      {/* Desktop Table View */}
                      <div className="hidden md:block overflow-x-auto mt-8">
                        <table className="min-w-full border-collapse border shadow-lg rounded-xl">
                          <thead>
                            <tr className="bg-blue-200">
                              <th className="border px-6 py-3 text-left">
                                Day
                              </th>
                              <th className="border px-6 py-3 text-left">
                                Breaks
                              </th>{" "}
                              {/* Combined cell for breaks */}
                            </tr>
                          </thead>
                          <tbody>
                            { 
                              filteredDataByWeek().map((item) => (
                                <tr key={item.id} className="hover:bg-blue-100">
                                  <td className="border px-6 py-3 text-blue-700">
                                    {getDayName(item.weekday_id)}
                                  </td>
                                  <td className="border px-6 py-3 text-blue-700">
                                    {/* Conditional display of breaks */}
                                    {breakData.length > 0 && (
                                      <div className="p-2 border border-gray-400 rounded-md flex space-x-2 items-center">
                                        {breakData.map(
                                          (breakItem) =>
                                            breakItem.weekday_id ===
                                              item.weekday_id && (
                                              <div
                                                key={breakItem.id}
                                                className="flex items-center"
                                              >
                                                <span className="font-semibold text-blue-600">
                                                  {breakItem.break_start}
                                                </span>
                                                <span className="mx-2 text-gray-500">
                                                  -
                                                </span>
                                                <span className="font-semibold text-blue-600">
                                                  {breakItem.break_end}
                                                </span>
                                                <button
                                                  onClick={() =>
                                                    handleDeleteBreak(
                                                      breakItem.id
                                                    )
                                                  }
                                                  className="text-red-600 ml-2"
                                                >
                                                  <RiDeleteBin5Line size={20} />
                                                </button>
                                              </div>
                                            )
                                        )}
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              ))
                          }
                          </tbody>
                        </table>
                      </div>

                      {/* Mobile Card View */}
                      <div className="md:hidden w-full">
                        {isLoading ? (
                          <div className="text-center p-4 bg-white rounded-lg shadow w-full">
                            Loading...
                          </div>
                        ) : (
                          <div className="w-full space-y-4">
                            {filteredDataByWeek().map((item) => (
                              <div
                                key={item.id}
                                className="bg-white rounded-lg shadow w-full overflow-hidden border border-gray-200"
                              >
                                <div className="bg-blue-200 p-3 font-semibold text-blue-800 w-full">
                                  {getDayName(item.weekday_id)}
                                </div>
                                <div className="p-4 w-full">
                                  {/* Existing Breaks */}
                                  {breakData.length > 0 &&
                                    breakData.some(
                                      (breakItem) =>
                                        breakItem.weekday_id === item.weekday_id
                                    ) && (
                                      <div className="mt-4 w-full">
                                        <h3 className="text-sm font-bold text-gray-700 mb-2">
                                          Current Breaks
                                        </h3>
                                        <div className="space-y-2 w-full">
                                          {breakData.map(
                                            (breakItem) =>
                                              breakItem.weekday_id ===
                                                item.weekday_id && (
                                                <div
                                                  key={breakItem.id}
                                                  className="p-3 border border-gray-300 rounded-md flex justify-between items-center w-full"
                                                >
                                                  <div>
                                                    <span className="font-semibold text-blue-600">
                                                      {breakItem.break_start}
                                                    </span>
                                                    <span className="mx-2 text-gray-500">
                                                      -
                                                    </span>
                                                    <span className="font-semibold text-blue-600">
                                                      {breakItem.break_end}
                                                    </span>
                                                  </div>
                                                  <button
                                                    onClick={() =>
                                                      handleDeleteBreak(
                                                        breakItem.id
                                                      )
                                                    }
                                                    className="text-red-600 p-2"
                                                    aria-label="Delete break"
                                                  >
                                                    <RiDeleteBin5Line
                                                      size={22}
                                                    />
                                                  </button>
                                                </div>
                                              )
                                          )}
                                        </div>
                                      </div>
                                    )}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {activeSubTab === "OFF TIME" && (
                    <div className="p-3 sm:p-6 space-y-6 sm:space-y-8 bg-gray-50 rounded-lg">
                      {/* Header Section - improved spacing and visual hierarchy */}
                      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-b border-gray-200 pb-4">
                        <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-800">
                          Add Your OFF Time
                        </h2>
                      </div>

                      {/* Added Off Times Section - Enhanced card styling */}
                      <div className="mt-4 sm:mt-8">
                        <h2 className="text-lg sm:text-xl font-bold text-gray-800 mb-4 flex items-center">
                          <span>Your Added OFF Times</span>
                          <span className="ml-3 bg-gray-200 text-gray-700 text-sm py-1 px-3 rounded-full">
                            {offTimes.length}
                          </span>
                        </h2>

                        {/* Mobile Card View - enhanced with better spacing and visual cues */}
                        <div className="block sm:hidden">
                          {offTimes.length > 0 ? (
                            <div className="space-y-4">
                              {offTimes.map((offTime) => (
                                <div
                                  key={offTime.id}
                                  className="bg-white rounded-lg border border-gray-200 p-4 shadow-sm hover:shadow-md transition-shadow duration-200"
                                >
                                  <div className="flex justify-between items-center mb-3">
                                    <div className="font-semibold text-gray-700 bg-gray-100 px-2 py-1 rounded">
                                      #{offTime.id}
                                    </div>
                                    <button
                                      onClick={() => handleDelete(offTime.id)}
                                      className="text-red-600 p-1 hover:bg-red-50 rounded-full transition-colors duration-200"
                                      aria-label="Delete"
                                    >
                                      <RiDeleteBin5Line size={20} />
                                    </button>
                                  </div>
                                  <div className="space-y-3">
                                    <div className="bg-blue-50 rounded-lg p-3">
                                      <div className="text-sm text-blue-700 font-medium mb-1">
                                        Start
                                      </div>
                                      <div className="flex justify-between items-center">
                                        <div className="text-sm font-medium">
                                          {offTime.start_date}
                                        </div>
                                        <div className="text-sm font-medium bg-blue-100 px-2 py-1 rounded">
                                          {offTime.start_time}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="bg-purple-50 rounded-lg p-3">
                                      <div className="text-sm text-purple-700 font-medium mb-1">
                                        End
                                      </div>
                                      <div className="flex justify-between items-center">
                                        <div className="text-sm font-medium">
                                          {offTime.end_date}
                                        </div>
                                        <div className="text-sm font-medium bg-purple-100 px-2 py-1 rounded">
                                          {offTime.end_time}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="text-center py-8 bg-white rounded-lg border border-gray-200 shadow-sm">
                              <p className="text-gray-500">
                                No off time data available
                              </p>
                            </div>
                          )}
                        </div>

                        {/* Desktop Table View - improved with better spacing and hover effects */}
                        <div className="hidden sm:block overflow-hidden border border-gray-200 rounded-lg shadow-sm">
                          <table className="min-w-full bg-white text-sm">
                            <thead className="bg-gradient-to-r from-gray-100 to-gray-200">
                              <tr>
                                <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                  #
                                </th>
                                <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                  Start Date
                                </th>
                                <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                  Start Time
                                </th>
                                <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                  End Date
                                </th>
                                <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                  End Time
                                </th>
                                <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-100">
                              {offTimes.length > 0 ? (
                                offTimes.map((offTime) => (
                                  <tr
                                    key={offTime.id}
                                    className="hover:bg-gray-50 transition-colors duration-150"
                                  >
                                    <td className="px-4 py-3 font-medium">
                                      {offTime.id}
                                    </td>
                                    <td className="px-4 py-3">
                                      {offTime.start_date}
                                    </td>
                                    <td className="px-4 py-3">
                                      <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs">
                                        {offTime.start_time}
                                      </span>
                                    </td>
                                    <td className="px-4 py-3">
                                      {offTime.end_date}
                                    </td>
                                    <td className="px-4 py-3">
                                      <span className="bg-purple-100 text-purple-800 px-2 py-1 rounded-full text-xs">
                                        {offTime.end_time}
                                      </span>
                                    </td>
                                    <td className="px-4 py-3">
                                      <button
                                        onClick={() => handleDelete(offTime.id)}
                                        className="text-red-600 p-1.5 hover:bg-red-50 rounded-full transition-colors duration-200"
                                        aria-label="Delete off time"
                                      >
                                        <RiDeleteBin5Line size={18} />
                                      </button>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan={6}
                                    className="px-4 py-8 text-center text-gray-500"
                                  >
                                    <p>No off time data available</p>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      {/* Delete Confirmation Modal - improved styling */}
                      {showDeleteModaloff && (
                        <div className="fixed inset-0 flex items-center justify-center z-50 bg-gray-800 bg-opacity-60 backdrop-blur-sm p-4">
                          <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md transform transition-all animate-fade-in">
                            <h2 className="text-lg font-semibold text-gray-800 text-center">
                              Are you sure you want to delete this off time?
                            </h2>
                            <p className="text-gray-500 text-center mt-2 text-sm">
                              This action cannot be undone.
                            </p>
                            <div className="mt-6 flex justify-center gap-4">
                              <button
                                onClick={confirmDelete}
                                className="px-5 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors duration-200 font-medium"
                              >
                                Yes, Delete
                              </button>
                              <button
                                onClick={cancelDelete}
                                className="px-5 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors duration-200 font-medium"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {activeSubTab === "OFF DAYS" && (
                    <div className="p-2 sm:p-6 space-y-6 sm:space-y-12">
                      {/* Header */}
                      <div className="flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-0 mb-6">
                        <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-800 text-center sm:text-left">
                          Select Your Off Days
                        </h2>
                      </div>

                      {/* Scrollable Calendar Section */}
                      <div className="overflow-x-auto">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-8">
                          {months.map((month) => (
                            <div
                              key={month}
                              className="border border-gray-300 rounded-lg p-2 sm:p-4 shadow-sm"
                            >
                              <div className="flex justify-between items-center mb-4">
                                <h3 className="text-md sm:text-lg font-bold text-gray-700">
                                  {month}
                                </h3>
                                <input
                                  type="checkbox"
                                  className="h-4 w-4 text-blue-500 focus:ring-blue-400"
                                  checked={fullMonth[month] || false}
                                  onChange={() => toggleMonth(month)}
                                />
                              </div>

                              <div className="overflow-x-auto">
                                <table className="w-full min-w-max text-center border-collapse border border-gray-200">
                                  <thead>
                                    <tr>
                                      {[
                                        "Mon",
                                        "Tue",
                                        "Wed",
                                        "Thu",
                                        "Fri",
                                        "Sat",
                                        "Sun",
                                      ].map((day) => (
                                        <th
                                          key={day}
                                          className="px-1 sm:px-2 py-1 text-xs sm:text-sm font-medium text-gray-600 border border-gray-200"
                                        >
                                          {day}
                                        </th>
                                      ))}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {[...Array(5)].map((_, weekIndex) => (
                                      <tr key={weekIndex}>
                                        {[...Array(7)].map((_, dayIndex) => {
                                          const dayNumber =
                                            weekIndex * 7 + dayIndex - 2;
                                          if (dayNumber <= 0 || dayNumber > 31)
                                            return (
                                              <td
                                                key={dayIndex}
                                                className="px-1 sm:px-2 py-1 sm:py-2 text-gray-300 border border-gray-200"
                                              />
                                            );

                                          const formattedDate = new Date(
                                            new Date().getFullYear(),
                                            months.indexOf(month),
                                            dayNumber
                                          )
                                            .toISOString()
                                            .split("T")[0];
                                          const isSelected = isDaySelected(
                                            month,
                                            dayNumber
                                          );
                                          const isHoliday = isDayHoliday(
                                            month,
                                            dayNumber
                                          );
                                          const offDay = offDays.find(
                                            (offDay) =>
                                              offDay.off_date === formattedDate
                                          );

                                          return (
                                            <td
                                              key={dayIndex}
                                              className={`px-1 sm:px-2 py-1 sm:py-2 text-xs sm:text-sm cursor-pointer ${
                                                isSelected
                                                  ? "bg-blue-700 text-white"
                                                  : isHoliday && offDay
                                                  ? "bg-red-500 text-white"
                                                  : "text-gray-800"
                                              } border border-gray-200`}
                                              onClick={() =>
                                                isHoliday && offDay
                                                  ? handleDeleteOffDay(offDay)
                                                  : toggleDay(month, dayNumber)
                                              }
                                            >
                                              {dayNumber}
                                            </td>
                                          );
                                        })}
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
       
  </div>
  );
};

export default Addstaff;

